import template from './state-change.pug';
import controller from './state-change.controller';

const StateChangeComponent = {
  template,
  controller,
  bindings: {
    case: '=',
    stateId: '<',
  },
};

export default StateChangeComponent;



// WEBPACK FOOTER //
// ./client/components/state-change/state-change.component.js